/**
 * @generated SignedSource<<0170b4a3bd7e52a30ec9bde86a4b494c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbShipping_viewer" | "PdpSharedSidebarBuyerIncentives_viewer">;
  readonly " $fragmentType": "PdpRespSidebarBlurbs_viewer";
};
export type PdpRespSidebarBlurbs_viewer$key = {
  readonly " $data"?: PdpRespSidebarBlurbs_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbs_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbShipping_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSidebarBuyerIncentives_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "3af59b641d44b0f221a551dd5a947b48";

export default node;
